import React, {useEffect, useState} from 'react'
import translate from '../../reusable/translate'
import PrimaryButton from '../buttons/PrimaryButton'
import SecondaryButton from '../buttons/SecondaryButton'
import ReactToPrint from 'react-to-print'
import {useDispatch, useSelector} from 'react-redux'
import {isMaterialOrGD} from "../helpers/Categories";
import {bindActionCreators} from "redux";
import commitmentSlice from "../../../state/slices/commitmentSlice";

const CommitmentReportContainer = ({ saveDraft, saveApproved, deleteDraft, printRef }) => {
    const dispatch = useDispatch()
    const [termsAccepted, setTermsAccepted] = useState(false)
    const [reportReminders, setReportReminders] = useState(false)
    const [authorizedOnBehalfConfirmed, setAuthorizedOnBehalfConfirmed] = useState(false)
    const [functionalBusinessConfirmed, setFunctionalBusinessConfirmed] = useState(false)
    const { changeReportingInterval, changeReportReminder } = bindActionCreators(commitmentSlice.actions, dispatch)

    const { commitment } = useSelector((state) => state)

    const changeReportReminders = (e) => {
        changeReportReminder({reminders: !reportReminders});
        setReportReminders(!reportReminders);
    }
    useEffect( () =>
    {
        if (!isMaterialOrGD(commitment.commitmentType) && commitment.organizationName === 'Yksityishenkilönä') {
            setFunctionalBusinessConfirmed(true);
            setAuthorizedOnBehalfConfirmed(true)
        }
    }, [])
    return(
        <div className="margin-top-bot do-not-print">


            {(commitment.isGreenDeal || commitment.commitmentType === 'GREEN_DEAL') &&
            <CheckBox
                textKey={'sit.commitmentCreation.greenDealCriteriaAccept'}
                action={() => {setTermsAccepted(!termsAccepted)}}
            />}


            {commitment.commitmentType === 'MATERIAL' &&
            <CheckBox
                textKey={'sit.commitmentCreation.materialCriteriaAccept'}
                action={() => {setTermsAccepted(!termsAccepted)}}
            />}

            {commitment.commitmentType === 'COMMITMENT' &&
            <CheckBox
                textKey={'sit.commitmentCreation.criteriaAccept'}
                action={() => {setTermsAccepted(!termsAccepted)}}
            />}

            {isMaterialOrGD(commitment.commitmentType) &&
            <CheckBox
                textKey={'sit.commitmentCreation.authorizedOnBehalf'}
                action={() => setAuthorizedOnBehalfConfirmed(!authorizedOnBehalfConfirmed)}
            />}

            {(commitment.commitmentType === 'COMMITMENT' && commitment.organizationName !== 'Yksityishenkilönä'
                && commitment.organizationName !== '') &&
            <CheckBox
                textKey={'sit.commitmentCreation.authorizedOnBehalf'}
                action={() => setAuthorizedOnBehalfConfirmed(!authorizedOnBehalfConfirmed)}
            />}

            {isMaterialOrGD(commitment.commitmentType) &&
            <CheckBox
                textKey={'sit.commitmentCreation.functionalBusiness'}
                action={() => setFunctionalBusinessConfirmed(!functionalBusinessConfirmed)}
            />}

            {(commitment.commitmentType === 'COMMITMENT' && commitment.organizationName !== 'Yksityishenkilönä'
                && commitment.organizationName !== '') &&
            <CheckBox
                textKey={'sit.commitmentCreation.functionalBusiness'}
                action={() => setFunctionalBusinessConfirmed(!functionalBusinessConfirmed)}
            />}


            {(commitment.commitmentType === 'COMMITMENT') &&
            <div>
            <div className="margin-top">
                Raportointimuistutusten väli :
            </div>

            <CheckBox
                textKey={'sit.commitmentCreation.reportReminderEmail'}
                action={() => changeReportReminders()}
            />
            <div className="radio">
                <label>
                    <input
                        type="radio"
                        value="MONTH_3"
                        checked={commitment.reportingInterval === "MONTH_3"}
                        onChange={(e) => {
                            changeReportingInterval({interval: e.target.value})}
                        }
                        label={translate({
                            textKey: "sit.commitmentCreation.everyThreeMonths"
                        })}
                    />
                    {translate({
                        textKey: "sit.commitmentCreation.everyThreeMonths"})}
                </label>
            </div>
            <div className="radio">
                <label>
                    <input
                        type="radio"
                        value="MONTH_6"
                        checked={commitment.reportingInterval === "MONTH_6"}
                        onChange={(e) => {
                            changeReportingInterval({interval: e.target.value})}
                        }
                        label={translate({
                            textKey: "sit.commitmentCreation.everySixMonths"
                        })}
                    />
                    {translate({
                        textKey: "sit.commitmentCreation.everySixMonths"})}
                </label>
            </div>
            <div className="radio">
                <label>
                    <input
                        type="radio"
                        value="MONTH_12"
                        checked={commitment.reportingInterval === "MONTH_12"}
                        onChange={(e) => {
                            changeReportingInterval({interval: e.target.value})}
                        }
                        label={translate({
                            textKey: "sit.commitmentCreation.everyTwelveMonths"
                        })}
                    />
                    {translate({
                    textKey: "sit.commitmentCreation.everyTwelveMonths"})}
                </label>
            </div>
            </div>}


            {isMaterialOrGD(commitment.commitmentType) && <div className="margin-top-bot">
                <p dangerouslySetInnerHTML={
                    {
                        __html: translate({
                            textKey: `sit.commitmentCreation.send.infotext.${commitment.commitmentCategoryId}`,
                            secondaryTextKey: 'sit.commitmentCreation.send.infotext'
                        })
                    }}
                />
            </div>
            }

            {!isMaterialOrGD(commitment.commitmentType) && <div className="margin-top-bot">
                <p dangerouslySetInnerHTML={
                    {
                        __html: translate({
                            textKey: `sit.commitmentCreation.send.infotext.commitment`
                        })
                    }}
                />
            </div>
            }

            <div className="flex-row space-evenly margin-top-bot">
                <PrimaryButton
                    action={() => saveApproved()}
                    disabled={!(termsAccepted && authorizedOnBehalfConfirmed && functionalBusinessConfirmed)}
                    textKey={ commitment.status !== 'approved' ? 'sit.commitmentCreation.sendForVerification' : 'sit.commitmentCreation.publishYourCommitment'}
                />

                {commitment.status !== 'approved' && (
                    <SecondaryButton
                        action={() => saveDraft()}
                        textKey={'sit.commitmentCreation.saveDraft'}
                    />
                )}

                {commitment.status === 'draft' && commitment.id &&
                <SecondaryButton
                    action={() => deleteDraft()}
                    textKey={'sit.commitmentCreation.deleteDraft'}
                />}

                <ReactToPrint content={() => printRef.current} trigger={() => <button className="secondary-button"><i className="fas fa-print"/> Tulostus</button>}/>
            </div>
        </div>
    )
}

export default CommitmentReportContainer

const CheckBox = ({ textKey, action }) => {
    return(
        <div className="flex-row">
            <input className="input-checkbox"
                textKey={textKey}
                type="checkbox"
                onChange={() => action()}/>
            <p className="p">{translate({ textKey: textKey })}</p>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/materialCommitment/commitment/CommitmentReportContainer.jsx